/*
 * @Author: Ly
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime : 2019-12-25 19:16:24
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\iWoprevireRouter.js
 * @Description:
 */
'use strict';
angular.module('iWoPreveiwRouterModule', ['iWoPreviewModule', 'iWoManuscriptPreviewModule', 'iwoSeriesSheetPreviewModule']).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('iwopreview', {
                url: '/iwopreview?iwochnldocid&iwometadataid&iwomodalname&iwodoccollectrelid&iwotype&fromType&departmentDocId&fromsearch',
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/iWoPreview/iwoRreview.html',
                        controller: 'iWoPreviewCtrl',
                    },
                },
            })
            .state('iwomanuscriptpreview', {
                url: '/iwomanuscriptpreview?iwochnldocid&iwometadataid&iwomodalname&iwodoccollectrelid&iwotype&fromType&departmentDocId&iwoplatform',
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/iWoPreview/manuscriptPreview/iwoManuscriptPreview_tpl.html',
                        controller: 'iWoManuscriptPreviewCtrl',
                    },
                },
            })
            .state('iwoseriessheetpreview', {
                url: '/iwoseriessheetpreview?iwoplatform&iwometadataid&iwochnldocid&iwomodalname&iwodoccollectrelid&iwotype&fromType&departmentDocId',
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/iWoPreview/seriesSheetPreview/iwoSeriesSheetPreview_tpl.html',
                        controller: 'iwoSeriesSheetPreviewCtrl',
                    },
                },
            });
    },
]);
